module.exports = __webpack_public_path__ + "img/16581256_L.536d0b3e.png";